var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-5"},[_c('h1',{staticClass:"text-h5 font-weight-medium mb-5"},[_vm._v(" Project Files ")]),(_vm.initialRequest)?_c('project-files-table',{attrs:{"initial-request":_vm.initialRequest,"small":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }